(() => {
  const GLOBAL_KEY = "GuerayProductEntryV3";
  const ENTRY_KEY = "gueray:product-entry-top";

  if (window[GLOBAL_KEY]) return;
  window[GLOBAL_KEY] = true;

  let forceTop = false;
  const hasEntryHash = window.location.hash === "#MainContent";

  try {
    forceTop =
      hasEntryHash || window.sessionStorage.getItem(ENTRY_KEY) === "1";
    if (forceTop) window.sessionStorage.removeItem(ENTRY_KEY);
  } catch (_error) {
    forceTop = false;
  }

  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  if (!forceTop) return;

  document.documentElement.classList.add("gy-product-entry-booting");

  let released = false;
  let userInteracted = false;

  const originalScrollTo = window.scrollTo.bind(window);
  const originalScroll = window.scroll.bind(window);
  const originalScrollBy = window.scrollBy.bind(window);
  const originalScrollIntoView = Element.prototype.scrollIntoView;
  const originalFocus = HTMLElement.prototype.focus;

  const shouldGuard = () => !released && !userInteracted;

  const requestedTop = (args) => {
    if (!args.length) return 0;
    if (typeof args[0] === "object" && args[0] !== null) {
      return Number(args[0].top || 0);
    }
    return Number(args[1] || 0);
  };

  window.scrollTo = (...args) => {
    if (shouldGuard() && requestedTop(args) > 8) return;
    return originalScrollTo(...args);
  };

  window.scroll = (...args) => {
    if (shouldGuard() && requestedTop(args) > 8) return;
    return originalScroll(...args);
  };

  window.scrollBy = (...args) => {
    if (shouldGuard()) return;
    return originalScrollBy(...args);
  };

  Element.prototype.scrollIntoView = function (...args) {
    if (shouldGuard()) return;
    return originalScrollIntoView.apply(this, args);
  };

  HTMLElement.prototype.focus = function (options) {
    if (shouldGuard()) {
      const safeOptions =
        options && typeof options === "object"
          ? { ...options, preventScroll: true }
          : { preventScroll: true };
      return originalFocus.call(this, safeOptions);
    }

    if (options === undefined) return originalFocus.call(this);
    return originalFocus.call(this, options);
  };

  const pinToTop = () => {
    if (shouldGuard()) originalScrollTo(0, 0);
  };

  const maintainTop = () => {
    if (!shouldGuard()) return;
    if (window.scrollY > 0 || window.scrollX > 0) {
      originalScrollTo(0, 0);
    }
    window.requestAnimationFrame(maintainTop);
  };

  const release = () => {
    if (released) return;
    released = true;
    document.documentElement.classList.remove("gy-product-entry-booting");

    window.scrollTo = originalScrollTo;
    window.scroll = originalScroll;
    window.scrollBy = originalScrollBy;

    if (Element.prototype.scrollIntoView !== originalScrollIntoView) {
      Element.prototype.scrollIntoView = originalScrollIntoView;
    }
    if (HTMLElement.prototype.focus !== originalFocus) {
      HTMLElement.prototype.focus = originalFocus;
    }

    if (hasEntryHash && window.location.hash === "#MainContent") {
      history.replaceState(
        history.state,
        "",
        `${window.location.pathname}${window.location.search}`,
      );
    }
  };

  const releaseForInteraction = () => {
    userInteracted = true;
    release();
  };

  ["pointerdown", "touchstart", "wheel", "keydown"].forEach((eventName) => {
    window.addEventListener(eventName, releaseForInteraction, {
      passive: true,
      once: true,
    });
  });

  pinToTop();
  window.requestAnimationFrame(maintainTop);

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      pinToTop();
      window.requestAnimationFrame(pinToTop);
    },
    { once: true },
  );

  window.addEventListener("pageshow", pinToTop, { once: true });
  window.addEventListener(
    "load",
    () => {
      pinToTop();
      window.requestAnimationFrame(() => {
        pinToTop();
        window.requestAnimationFrame(pinToTop);
      });
      window.setTimeout(release, 1400);
    },
    { once: true },
  );

  window.setTimeout(release, 8000);
})();
